(function () {
  'use strict';

  var CONFIG = (window.AEOC_CONFIG && window.AEOC_CONFIG.workerUrl)
    ? window.AEOC_CONFIG
    : { workerUrl: '' };

  if (!CONFIG.workerUrl) {
    console.warn('[AEOC] window.AEOC_CONFIG.workerUrl is not set — widget disabled.');
    return;
  }

  var HANDLE_MAP = {
    'clove-eucalyptus-mould-spray': 'Clove & Eucalyptus Mould Spray',
    'all-natural-mould-remover-wall-cleaner': 'All Natural Mould Remover Wall Cleaner',
    'lemon-myrtle-laundry-powder': 'Lemon Myrtle Laundry Powder',
    'eucalyptus-laundry-powder': 'Eucalyptus Laundry Powder',
    'lavender-laundry-powder': 'Lavender Laundry Powder',
    'lemon-myrtle-dishwasher-powder': 'Lemon Myrtle Dishwasher Powder',
    'eucalyptus-dishwasher-powder': 'Eucalyptus Dishwasher Powder',
    'all-natural-lemon-myrtle-bench-spray': 'All Natural Lemon Myrtle Bench Spray',
    'all-natural-eucalyptus-bench-spray': 'All Natural Eucalyptus Bench Spray',
    'all-natural-peppermint-bench-spray': 'All Natural Peppermint Bench Spray',
    'all-natural-citrus-burst-bench-spray': 'All Natural Citrus Burst Bench Spray',
    'eucalyptus-multi-purpose-cleaner': 'Eucalyptus Multi Purpose Cleaner',
    'lemon-myrtle-multi-purpose-cleaner': 'Lemon Myrtle Multi Purpose Cleaner',
    'peppermint-multi-purpose-cleaner': 'Peppermint Multi Purpose Cleaner',
    'lavender-multi-purpose-cleaner': 'Lavender Multi Purpose Cleaner',
    'all-natural-low-vapour-shower-cleaner': 'All Natural Low Vapour Shower Cleaner',
    'all-natural-dog-wash': 'All Natural Dog Wash',
    'blue-mallee-eucalyptus-oil': 'Blue Mallee Eucalyptus Oil',
    'pure-castile-soap-sensitive': 'Pure Castile Soap - Sensitive (Unscented)',
    'sample-pack': 'Sample Pack 6 x 100ml',
    // Titles for the LP-mapped handles below, so LPs send a non-empty pageContext and the
    // server greeting personalises (it keys on the title, not the handle — verified 2026-07-27).
    'mould-remover-wall-cleaner': 'All Natural Mould Remover Wall Cleaner',
    'bygum-spray-clean-for-mould': 'Clove & Eucalyptus Mould Spray',
    'all-natural-eucalyptus-hydrosol-glass-cleaner': 'Eucalyptus Glass Cleaner',
    'multi-purpose-cleaner': 'Eucalyptus Multi Purpose Cleaner',
    'mould-essentials-bundle-30-off-plus-free-shipping': 'Mould + Essentials Bundle',
    'complete-natural-home-bundle': 'Complete Natural Home Bundle'
  };

  // Landing pages live at /pages/<lp> and don't set window.aeocChatHandle, so the widget
  // used to fall back to the GENERIC hook/chips on paid cold traffic. Map each LP to the
  // product it sells so the LP inherits that product's tuned hook + quick-reply chips.
  var LP_TO_PRODUCT = {
    'mould-wall-cleaner-lp': 'mould-remover-wall-cleaner',
    'clove-euc-mould-spray-lp': 'bygum-spray-clean-for-mould',
    'shower-cleaner-lp': 'all-natural-low-vapour-shower-cleaner',
    'glass-cleaner-lp': 'all-natural-eucalyptus-hydrosol-glass-cleaner',
    'floor-cleaner-lp': 'multi-purpose-cleaner',
    'mould-essentials-bundle-lp': 'mould-essentials-bundle-30-off-plus-free-shipping',
    'natural-home-set': 'complete-natural-home-bundle'
  };

  function detectPageContext() {
    var handle = (typeof window.aeocChatHandle === 'string' && window.aeocChatHandle) || '';
    if (!handle) {
      var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) handle = m[1];
    }
    if (!handle) {
      var mp = window.location.pathname.match(/\/pages\/([^\/?#]+)/);
      if (mp && LP_TO_PRODUCT[mp[1]]) handle = LP_TO_PRODUCT[mp[1]];
    }
    var title = (typeof window.aeocChatContext === 'string' && window.aeocChatContext) || '';
    if (!title && handle && HANDLE_MAP[handle]) title = HANDLE_MAP[handle];
    return { title: title, handle: handle };
  }

  // Hook bubble text per page handle — a real question. Tapping the bubble sends this
  // straight to the bot as the opening message (skips the generic "Hi.") so a single tap
  // lands the customer in an answered conversation. Falls back to GENERIC_HOOK for unknown pages.
  var HOOK_MAP = {
    // Consolidated PDPs
    'aeoc-bench-spray': 'Is it safe on food benches?',
    'multi-purpose-cleaner': 'What can I clean with it?',
    'laundry-powder': 'Front or top loader?',
    'dishwasher-powder': 'Is it as good as Finish?',
    'pure-castile-hand-wash': 'Is it gentle on eczema?',
    'aeoc-dishwash-liquid': 'Does it cut grease?',
    'eucalyptus-dishwash-liquid-475-ml': 'Does it cut grease?',
    'unscented-dishwash-liquid-475-ml': 'Does it cut grease?',

    // Standalone PDPs
    'bygum-spray-clean-for-mould': 'Will it kill the mould for good?',
    'mould-remover-wall-cleaner': 'Is it right for painted walls?',
    'all-natural-eucalyptus-hydrosol-glass-cleaner': 'Will it leave streaks?',
    'all-natural-stainless-steel-cleaner': 'Will it leave streaks?',
    'all-natural-low-vapour-shower-cleaner': 'Will it shift soap scum?',
    'all-natural-dog-wash': 'Is it OK for sensitive skin?',
    'rinse-free-hand-wash': 'How does no-rinse work?',
    'bygum-all-natural-hydrating-body-oil': 'Does it absorb quickly?',

    // Room sprays (all 3)
    'bygum-all-natural-lavender-spray': 'Is it 100% real oil?',
    'bygum-all-natural-peppermint-spray': 'Is it 100% real oil?',
    'bygum-all-natural-lemon-myrtle-spray': 'Is it 100% real oil?',

    // Other specialty products
    'carrier-oils': 'Which carrier oil do I need?',
    'bygum-aussie-bush-spray': 'Does it keep mozzies off?',
    'bygum-all-natural-tea-tree-spray-size-125-ml': 'Good for smelly feet?',
    'bygum-eucalyptus-wool-mix': 'Is it safe for wool?',
    'bygum-eucalyptus-laundry-liquid': 'Front or top loader?',
    'pet-bedding-and-blanket-wash': 'Will it strip the smell?',
    'sample-pack': "What's in the sample pack?",
    'complete-natural-home-bundle': 'Which kit suits me?',
    'mould-essentials-bundle-30-off-plus-free-shipping': 'Which kit suits me?',
    'eucalyptus-myrtle-starter-pack': 'Which kit suits me?',
    'lemon-myrtle-starter-pack': 'Which kit suits me?',
    'peppermint-starter-pack': 'Which kit suits me?'
  };
  var GENERIC_HOOK = 'What can I help you find?';
  // Essential oil handles all share one hook — match by prefix in pickHookText().
  var ESSENTIAL_OIL_HOOK = 'Which oil for what?';
  var ESSENTIAL_OIL_HANDLES = [
    'bygum-blue-mallee-eucalyptus-oil','bygum-tea-tree-oil','bygum-lemon-myrtle-oil',
    'bygum-lemon-scented-tea-tree-oil','bygum-lemon-oil','bygum-orange-oil-sweet',
    'bygum-lavender-oil','bygum-peppermint-oil','bygum-clove-oil','bygum-frankincense-oil',
    'rosewood-essential-oil','cinnamon-oil','bygum-patchouli-oil','bygum-ylang-ylang-oil',
    'bygum-geranium-oil','bygum-wintergreen-oil','bygum-pine-oil','bygum-rosemary-oil',
    'bygum-lemongrass-oil','bygum-lime-oil','bygum-bergamot-oil','bygum-grapefruit-oil',
    'bygum-cedarwood-oil','bygum-citronella-oil','bygum-fennel-oil','bygum-juniper-berry-oil',
    'bygum-spearmint-oil'
  ];

  function pickHookText(handle) {
    if (!handle) return GENERIC_HOOK;
    if (HOOK_MAP[handle]) return HOOK_MAP[handle];
    if (ESSENTIAL_OIL_HANDLES.indexOf(handle) !== -1) return ESSENTIAL_OIL_HOOK;
    return GENERIC_HOOK;
  }

  // Quick-reply chips shown under the opening greeting — one tap answers the bot's
  // opening question, turning a "Hi." ghost-open into an engaged (and converting) session.
  // Chips are QUESTIONS only (never claims) so they can't introduce an unverified product fact.
  var CHIP_MAP = {
    'bygum-spray-clean-for-mould': ['Will it stop it coming back?', 'Safe around kids & pets?', 'Which surfaces?'],
    'mould-remover-wall-cleaner': ['Painted, or tiled?', 'Do I need to scrub?', 'Safe around kids & pets?'],
    'laundry-powder': ['Front or top loader?', 'Which scent?', 'Sensitive skin?'],
    'bygum-eucalyptus-laundry-liquid': ['Front or top loader?', 'How much per load?', 'Sensitive skin?'],
    'bygum-eucalyptus-wool-mix': ['Safe for wool & delicates?', 'How do I use it?', 'Machine or hand wash?'],
    'dishwasher-powder': ['As good as Finish?', 'How much per wash?', 'Which scent?'],
    'aeoc-bench-spray': ['Safe on food surfaces?', 'Which scent?', 'Bench spray vs multi-purpose?'],
    'multi-purpose-cleaner': ['What can I clean with it?', 'How do I dilute it?', 'Which scent?'],
    'all-natural-low-vapour-shower-cleaner': ['Shifts soap scum?', 'Low fumes?', 'Safe on glass & tiles?'],
    'all-natural-eucalyptus-hydrosol-glass-cleaner': ['No streaks?', 'Mirrors & screens?', 'How far does it go?'],
    'all-natural-stainless-steel-cleaner': ['Removes marks & grease?', 'Streak-free?', 'Which surfaces?'],
    'pure-castile-hand-wash': ['Sensitive / eczema skin?', 'Which scent?', 'Babies & kids OK?'],
    'aeoc-dishwash-liquid': ['Cuts grease?', 'Scented or unscented?', 'How concentrated?'],
    'eucalyptus-dishwash-liquid-475-ml': ['Cuts grease?', 'Scented or unscented?', 'How concentrated?'],
    'unscented-dishwash-liquid-475-ml': ['Cuts grease?', 'Scented or unscented?', 'How concentrated?'],
    'all-natural-dog-wash': ['Sensitive skin?', 'Puppy safe?', 'How often?'],
    'rinse-free-hand-wash': ['How does no-rinse work?', 'Drying on hands?', 'Kid safe?'],
    'bygum-all-natural-hydrating-body-oil': ['Quick to absorb?', "What's in it?", 'Face & sensitive skin?'],
    'bygum-all-natural-lavender-spray': ['100% real oil?', 'Safe around kids & pets?', 'How long does it last?'],
    'bygum-all-natural-peppermint-spray': ['100% real oil?', 'Safe around kids & pets?', 'How long does it last?'],
    'bygum-all-natural-lemon-myrtle-spray': ['100% real oil?', 'Safe around kids & pets?', 'How long does it last?'],
    'carrier-oils': ['Which carrier oil?', 'For diluting oils?', 'Skin or hair?'],
    'bygum-aussie-bush-spray': ['Keeps mozzies off?', 'Kid safe?', 'How do I use it?'],
    'bygum-all-natural-tea-tree-spray-size-125-ml': ['For smelly feet & shoes?', 'How do I use it?', 'Safe on skin?'],
    'pet-bedding-and-blanket-wash': ['Strips the smell?', 'How do I use it?', 'Sensitive pets?'],
    'sample-pack': ["What's in it?", 'Which products?', 'Good way to try first?'],
    'complete-natural-home-bundle': ['Which kit suits me?', "What's included?", 'Is it better value?'],
    'mould-essentials-bundle-30-off-plus-free-shipping': ['Which kit suits me?', "What's included?", 'Is it better value?'],
    'eucalyptus-myrtle-starter-pack': ['Which kit suits me?', "What's included?", 'Is it better value?'],
    'lemon-myrtle-starter-pack': ['Which kit suits me?', "What's included?", 'Is it better value?'],
    'peppermint-starter-pack': ['Which kit suits me?', "What's included?", 'Is it better value?']
  };
  var ESSENTIAL_OIL_CHIPS = ['Which oil for what?', 'How do I use it safely?', 'Blend ideas?'];
  var GENERIC_CHIPS = ['Help me pick', 'Mould help', 'Free shipping?'];

  function pickChips(handle) {
    if (handle && CHIP_MAP[handle]) return CHIP_MAP[handle];
    if (handle && ESSENTIAL_OIL_HANDLES.indexOf(handle) !== -1) return ESSENTIAL_OIL_CHIPS;
    return GENERIC_CHIPS;
  }

  // --- Hook stack: three question bubbles instead of one -------------------
  // MULTI_HOOK true → at trigger time up to three small tappable question pills
  // appear ABOVE the launcher (hook question first, then the page's chips minus
  // near-duplicates). Tap = that question opens the chat. The launcher icon stays
  // visible throughout — the pills are an extra way in, never a replacement.
  // ✕ or a tap ends it for the session; a 12s timeout only ends it for this page.
  // false → original single hook bubble beside the launcher. One-line rollback.
  var MULTI_HOOK = true;
  function pickHookStack(handle) {
    var hook = pickHookText(handle);
    // Unknown pages: the generic chips stand alone better than the generic
    // hook ("What can I help you find?" + "Help me pick" is redundant).
    if (hook === GENERIC_HOOK) return GENERIC_CHIPS.slice(0, 3);
    function norm(s) { return s.toLowerCase().replace(/[^a-z0-9 ]/g, '').trim(); }
    function words(s) { return norm(s).split(/\s+/).filter(function (w) { return w.length >= 4; }); }
    var out = [hook], hw = words(hook), hn = norm(hook);
    var chips = pickChips(handle);
    for (var i = 0; i < chips.length && out.length < 3; i++) {
      var cn = norm(chips[i]);
      if (cn === hn || hn.indexOf(cn) !== -1 || cn.indexOf(hn) !== -1) continue; // duplicate of the hook
      var shared = 0, sharedLong = 0, cw = words(chips[i]);
      for (var j = 0; j < cw.length; j++) {
        if (hw.indexOf(cw[j]) !== -1) { shared++; if (cw[j].length >= 5) sharedLong++; }
      }
      if (shared >= 2 || sharedLong >= 1) continue; // same question, reworded
      out.push(chips[i]);
    }
    return out;
  }

  var STYLES = [
    '.aeoc-chat-launcher{position:fixed;bottom:20px;right:20px;width:56px;height:56px;border-radius:50%;background:#89a999;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center;z-index:2147483646;transition:transform .15s ease;font-family:system-ui,-apple-system,sans-serif}',
    '.aeoc-chat-launcher:hover{transform:scale(1.06)}',
    '.aeoc-chat-launcher svg{width:28px;height:28px;display:block}',
    '.aeoc-chat-launcher.aeoc-chat-hidden{display:none}',
    '.aeoc-chat-panel{position:fixed;bottom:20px;right:20px;width:380px;height:540px;max-height:calc(100vh - 40px);background:#fff;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.18);display:none;flex-direction:column;overflow:hidden;z-index:2147483646;font-family:system-ui,-apple-system,sans-serif;color:#111}',
    '.aeoc-chat-panel.aeoc-chat-open{display:flex}',
    '.aeoc-chat-header{background:#89a999;color:#fff;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0}',
    '.aeoc-chat-header-title{font-weight:600;font-size:15px;letter-spacing:.2px}',
    '.aeoc-chat-header-sub{font-size:11px;opacity:.85;margin-top:1px}',
    '.aeoc-chat-close{background:transparent;border:none;color:#fff;cursor:pointer;padding:4px;border-radius:6px;opacity:.85}',
    '.aeoc-chat-close:hover{opacity:1;background:rgba(255,255,255,.12)}',
    '.aeoc-chat-close svg{width:18px;height:18px;display:block}',
    '.aeoc-chat-messages{flex:1;overflow-y:auto;padding:16px 14px;background:#fff;display:flex;flex-direction:column;gap:8px}',
    '.aeoc-chat-bubble{max-width:82%;padding:10px 14px;border-radius:18px;font-size:14.5px;font-weight:400;line-height:1.45;word-wrap:break-word;white-space:pre-wrap}',
    '.aeoc-chat-bubble strong{font-weight:700}',
    '.aeoc-chat-bubble em{font-weight:400}',
    '.aeoc-chat-bubble.aeoc-chat-bot{background:#F4F4F2;color:#000;align-self:flex-start;border-bottom-left-radius:6px}',
    '.aeoc-chat-bubble.aeoc-chat-user{background:#4a7a6a;color:#fff;align-self:flex-end;border-bottom-right-radius:6px}',
    '.aeoc-chat-typing{display:inline-flex;gap:4px;align-items:center;padding:12px 14px;background:#F4F4F2;border-radius:18px;border-bottom-left-radius:6px;align-self:flex-start}',
    '.aeoc-chat-typing span{width:6px;height:6px;background:#888;border-radius:50%;animation:aeoc-chat-bounce 1.2s infinite}',
    '.aeoc-chat-typing span:nth-child(2){animation-delay:.15s}',
    '.aeoc-chat-typing span:nth-child(3){animation-delay:.3s}',
    '@keyframes aeoc-chat-bounce{0%,60%,100%{transform:translateY(0);opacity:.5}30%{transform:translateY(-4px);opacity:1}}',
    '.aeoc-chat-input-wrap{border-top:1px solid #EEE;padding:10px 12px;display:flex;gap:8px;align-items:flex-end;flex-shrink:0;background:#fff}',
    '.aeoc-chat-input{flex:1;border:1px solid #D9D9D9;border-radius:12px;padding:9px 12px;font-size:14.5px;font-weight:400;font-family:inherit;resize:none;outline:none;line-height:1.4;max-height:90px;min-height:40px;background:#fff;color:#111}',
    '.aeoc-chat-input:focus{border-color:#89a999}',
    '.aeoc-chat-send{background:#89a999;color:#fff;border:none;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0}',
    '.aeoc-chat-send:disabled{opacity:.4;cursor:not-allowed}',
    '.aeoc-chat-send svg{width:18px;height:18px;display:block}',
    '.aeoc-chat-error{background:#FDECEA;color:#8a1f12;padding:8px 12px;font-size:13px;border-radius:10px;align-self:stretch;text-align:center}',
    '.aeoc-chat-chips{display:flex;flex-wrap:wrap;gap:6px;margin:2px 0 4px;align-self:flex-start;max-width:100%}',
    '.aeoc-chat-chip{background:#fff;color:#3f5a4d;border:1px solid #89a999;border-radius:16px;padding:6px 12px;font-size:13px;font-weight:500;font-family:inherit;line-height:1.3;cursor:pointer;transition:background .12s ease,color .12s ease}',
    '.aeoc-chat-chip:hover{background:#89a999;color:#fff}',
    '.aeoc-chat-hook{position:fixed;bottom:88px;right:20px;background:#fff;color:#111;border-radius:14px;box-shadow:0 6px 22px rgba(0,0,0,.15);padding:11px 14px 11px 16px;font-family:system-ui,-apple-system,sans-serif;font-size:14.5px;font-weight:600;line-height:1.3;z-index:2147483645;display:none;align-items:center;gap:8px;max-width:240px;cursor:pointer;opacity:0;transform:translateY(8px);transition:opacity .25s ease,transform .25s ease}',
    '.aeoc-chat-hook.aeoc-chat-hook-visible{display:inline-flex;opacity:1;transform:translateY(0)}',
    '.aeoc-chat-hook:hover{box-shadow:0 8px 28px rgba(0,0,0,.2)}',
    '.aeoc-chat-hook-text{flex:1;color:#1a1a18}',
    '.aeoc-chat-hook-close{flex-shrink:0;background:transparent;border:none;color:#888;cursor:pointer;padding:2px;border-radius:4px;line-height:0;margin-left:4px}',
    '.aeoc-chat-hook-close:hover{color:#111;background:rgba(0,0,0,.06)}',
    '.aeoc-chat-hook-close svg{width:14px;height:14px;display:block}',
    '.aeoc-chat-hook::after{content:"";position:absolute;bottom:-7px;right:26px;width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #fff;filter:drop-shadow(0 2px 1px rgba(0,0,0,.08))}',
    '.aeoc-chat-launcher.aeoc-chat-tucked{display:none}',
    // Sits ABOVE the launcher (56px icon at bottom:20px + 12px gap), never on top of
    // it — the icon stays put so she always has the familiar way in.
    '.aeoc-chat-hookstack{position:fixed;bottom:88px;right:20px;display:none;flex-direction:column;align-items:flex-end;gap:4px;z-index:2147483645;font-family:system-ui,-apple-system,sans-serif;opacity:0;transform:scale(.25);transform-origin:bottom right;transition:opacity .2s ease,transform .2s ease}',
    '.aeoc-chat-hookstack.aeoc-chat-hookstack-visible{display:flex;opacity:1;transform:none}',
    '.aeoc-chat-hookstack.aeoc-chat-hookstack-tucked{opacity:0;transform:scale(.25);pointer-events:none}',
    '.aeoc-chat-hookpill{background:#fff;color:#3f5a4d;border:1px solid #89a999;border-radius:14px;padding:6px 11px;font-size:12.5px;font-weight:600;font-family:inherit;line-height:1.25;box-shadow:0 2px 7px rgba(0,0,0,.14);cursor:pointer;transition:background .12s ease,color .12s ease}',
    '.aeoc-chat-hookpill:hover{background:#89a999;color:#fff}',
    '.aeoc-chat-hookstack-close{background:rgba(255,255,255,.92);border:1px solid #ccc;color:#888;border-radius:50%;width:18px;height:18px;font-size:10px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;margin-bottom:-1px;padding:0}',
    '.aeoc-chat-hookstack-close:hover{color:#111;border-color:#999}',
    '@media (max-width:480px){.aeoc-chat-panel{width:100%;right:0;left:0;bottom:0;height:90vh;max-height:90vh;border-radius:16px 16px 0 0}}',
    '@media (max-width:640px){.aeoc-chat-hook{bottom:140px !important}.aeoc-chat-hookstack{bottom:140px}}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('aeoc-chat-styles')) return;
    var style = document.createElement('style');
    style.id = 'aeoc-chat-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      }
    }
    if (children) {
      for (var i = 0; i < children.length; i++) {
        if (children[i]) node.appendChild(children[i]);
      }
    }
    return node;
  }

  var ICON_LEAF = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill="white" fill-opacity="0.55" d="M14 6 H27 a2.5 2.5 0 0 1 2.5 2.5 V14 a2.5 2.5 0 0 1 -2.5 2.5 H23 L20 19 V16.5 H14 a2.5 2.5 0 0 1 -2.5 -2.5 V8.5 a2.5 2.5 0 0 1 2.5 -2.5 Z"/><path fill="white" d="M5 13 H18 a2.5 2.5 0 0 1 2.5 2.5 V21 a2.5 2.5 0 0 1 -2.5 2.5 H11 L8 26 V23.5 H5 a2.5 2.5 0 0 1 -2.5 -2.5 V15.5 a2.5 2.5 0 0 1 2.5 -2.5 Z"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>';

  function uuid() {
    // RFC4122 v4-ish, plenty for session tagging
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // ---------- GA4 attribution (Layer 2) ----------
  // Fires custom events to GA4 so chat-influenced sessions can be attributed even when
  // the customer doesn't click Tony's link. Safe no-op if gtag isn't installed.
  function trackGa4(eventName, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
    } catch (e) { /* analytics never breaks the chat */ }
  }
  function setGa4UserProperty(name, value) {
    try {
      if (typeof window.gtag === 'function') {
        var props = {};
        props[name] = value;
        window.gtag('set', 'user_properties', props);
      }
    } catch (e) { /* silent */ }
  }

  // ---------- Shopify cart attribution (Layer 3) ----------
  // Attaches custom attributes to the customer's cart so any order they place carries
  // the chatbot_session_id. Shopify merges attributes — won't clobber anything else.
  // Silent no-op when not on Shopify (e.g. local preview).
  function tagShopifyCart() {
    try {
      if (typeof window.fetch !== 'function') return;
      var attrs = {
        chatbot_session_id: state.sessionId,
        chatbot_engaged_at: new Date().toISOString()
      };
      if (state.pageHandle) attrs.chatbot_handle_seen = state.pageHandle;
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        credentials: 'same-origin'
      }).catch(function () { /* silent — local preview or non-Shopify host */ });
    } catch (e) { /* defensive — attribution never breaks the chat */ }
  }

  // UTM-tag AEOC product URLs for analytics attribution.
  // Displayed link text stays clean; only the href gets the tracking params.
  // Catches: https://australianeucalyptusoil.com.au/products/<handle> (with or without trailing slash/query)
  var AEOC_PRODUCT_URL_RE = /^https?:\/\/(?:www\.)?australianeucalyptusoil\.com\.au\/products\/([a-z0-9-]+)/i;
  function buildUtmHref(url) {
    var m = url.match(AEOC_PRODUCT_URL_RE);
    if (!m) return url; // not a product URL — leave alone (no UTM on non-product links)
    var handle = m[1];
    // Don't double-tag if UTM params already present
    if (/[?&]utm_source=/i.test(url)) return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'utm_source=tony&utm_medium=chat&utm_campaign=' + encodeURIComponent(handle);
  }

  // Minimal markdown renderer for bot bubbles — handles **bold**, *italic*, clickable URLs, bullet markers.
  // Escapes HTML first to prevent any injection from streamed content.
  function renderMarkdown(text) {
    if (!text) return '';
    var html = String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    // Bold (process before italic so ** isn't mistaken as a pair of italic markers)
    html = html.replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>');
    // Italic — conservative match so it doesn't trigger on stray asterisks mid-word
    html = html.replace(/(^|[\s(,])\*([^*\n]+?)\*(?=[\s.,!?)]|$)/g, '$1<em>$2</em>');
    // URLs become clickable (opens in new tab, no referrer leak). AEOC product URLs get UTM params injected into href; displayed text stays clean.
    html = html.replace(/(https?:\/\/[^\s<>"]+)/g, function (url) {
      return '<a href="' + buildUtmHref(url) + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
    });
    // Convert "- " bullet markers at start of line to a real bullet character (white-space:pre-wrap keeps newlines)
    html = html.replace(/^- /gm, '• ');
    return html;
  }

  // Conversation persistence across page navigations (within a tab session).
  // Restored on init from sessionStorage so the customer can navigate AEOC's site
  // and pick the chat back up where she left off. Cleared when the tab closes.
  var CONVERSATION_KEY = 'aeoc-chat-conversation';
  function loadPersistedConversation() {
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(CONVERSATION_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      // Validate shape — defensive against stale schemas
      if (!parsed || !Array.isArray(parsed.messages)) return null;
      return parsed;
    } catch (e) { return null; }
  }
  function persistConversation() {
    try {
      if (!window.sessionStorage) return;
      var payload = {
        v: 1,
        sessionId: state.sessionId,
        messages: state.messages,
        sentOpening: state.sentOpening,
        ga4OpenedFired: state.ga4OpenedFired,
        ga4EngagedFired: state.ga4EngagedFired,
        savedAt: Date.now()
      };
      window.sessionStorage.setItem(CONVERSATION_KEY, JSON.stringify(payload));
    } catch (e) { /* quota full / private mode — silent fallback to in-memory only */ }
  }

  // Initial state — hydrate from sessionStorage if a prior conversation exists in this tab.
  var __persisted = loadPersistedConversation();
  var state = {
    messages: __persisted ? __persisted.messages : [],
    isStreaming: false,
    pageContext: '',
    pageHandle: '',
    sessionId: __persisted ? __persisted.sessionId : uuid(),
    opened: false, // panel always re-collapses to icon on navigation — she clicks to resume
    sentOpening: __persisted ? !!__persisted.sentOpening : false,
    hookShown: false,
    hookAutoHideTimer: null,
    hookDelayTimer: null,
    hookScrollHandler: null,
    ga4OpenedFired: __persisted ? !!__persisted.ga4OpenedFired : false,
    ga4EngagedFired: __persisted ? !!__persisted.ga4EngagedFired : false
  };

  // Hook dismissal. Two different things she can do, and they must not be conflated:
  //   ACTED  (tapped a pill, or hit ✕, or opened the chat) → she's answered the
  //          invitation, so don't hook again for the rest of the session.
  //   IGNORED (the 12s auto-hide fired while she read on) → that's not a refusal.
  //          Suppress it on THIS page only; the next page gets another turn, up to
  //          MAX_HOOK_SHOWS. A shopper who dwells on the homepage shouldn't arrive at
  //          the mould PDP with the hook already spent.
  var HOOK_DISMISS_KEY = 'aeoc-chat-hook-dismissed';
  var HOOK_SHOWS_KEY = 'aeoc-chat-hook-shows';
  var MAX_HOOK_SHOWS = 3;
  function isHookDismissed() {
    try { return window.sessionStorage && window.sessionStorage.getItem(HOOK_DISMISS_KEY) === '1'; }
    catch (e) { return false; }
  }
  function markHookDismissed() {
    try { window.sessionStorage && window.sessionStorage.setItem(HOOK_DISMISS_KEY, '1'); }
    catch (e) { /* private mode etc — fine, fall back to in-memory flag */ }
    state.hookShown = true;
  }
  function hookShowCount() {
    try { return parseInt(window.sessionStorage.getItem(HOOK_SHOWS_KEY), 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpHookShowCount() {
    try { window.sessionStorage.setItem(HOOK_SHOWS_KEY, String(hookShowCount() + 1)); }
    catch (e) { /* private mode — cap falls back to once per page load */ }
  }
  // Spent = she's answered it, or we've already used our three turns.
  function hooksExhausted() { return isHookDismissed() || hookShowCount() >= MAX_HOOK_SHOWS; }

  var ui = {};

  function build() {
    injectStyles();

    ui.launcher = el('button', { class: 'aeoc-chat-launcher', 'aria-label': 'Open chat' });
    ui.launcher.innerHTML = ICON_LEAF;
    ui.launcher.addEventListener('click', openPanel);

    ui.panel = el('div', { class: 'aeoc-chat-panel', role: 'dialog', 'aria-label': 'AEOC chat' });

    var headerText = el('div', null, [
      el('div', { class: 'aeoc-chat-header-title', text: 'AEOC' }),
      el('div', { class: 'aeoc-chat-header-sub', text: 'Natural cleaning, since 1895' })
    ]);
    var closeBtn = el('button', { class: 'aeoc-chat-close', 'aria-label': 'Close chat' });
    closeBtn.innerHTML = ICON_CLOSE;
    closeBtn.addEventListener('click', closePanel);
    ui.header = el('div', { class: 'aeoc-chat-header' }, [headerText, closeBtn]);

    ui.messages = el('div', { class: 'aeoc-chat-messages' });
    // GA4: event-delegation for clicks on AEOC product links Tony shares. Catches every link
    // Tony streams without needing to re-bind per bubble. Fires `chatbot_link_clicked`.
    ui.messages.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var m = href.match(/\/products\/([a-z0-9-]+)/i);
      if (!m) return;
      trackGa4('chatbot_link_clicked', {
        chatbot_session_id: state.sessionId,
        product_handle: m[1],
        link_url: href
      });
    });

    ui.input = el('textarea', { class: 'aeoc-chat-input', rows: '1', placeholder: 'Ask anything…' });
    ui.input.addEventListener('input', autosize);
    ui.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSend();
      }
    });
    // Mobile: when keyboard opens, wait for it to finish animating then scroll
    // the message list so the latest reply stays in view above the input.
    ui.input.addEventListener('focus', function () {
      setTimeout(function () {
        if (ui.messages) ui.messages.scrollTop = ui.messages.scrollHeight;
      }, 350);
    });
    ui.sendBtn = el('button', { class: 'aeoc-chat-send', 'aria-label': 'Send' });
    ui.sendBtn.innerHTML = ICON_SEND;
    ui.sendBtn.addEventListener('click', handleSend);
    var inputWrap = el('div', { class: 'aeoc-chat-input-wrap' }, [ui.input, ui.sendBtn]);

    ui.panel.appendChild(ui.header);
    ui.panel.appendChild(ui.messages);
    ui.panel.appendChild(inputWrap);

    // Hook bubble — built once, shown only when triggers fire.
    ui.hookText = el('span', { class: 'aeoc-chat-hook-text' });
    var hookCloseBtn = el('button', { class: 'aeoc-chat-hook-close', 'aria-label': 'Dismiss' });
    hookCloseBtn.innerHTML = ICON_CLOSE;
    hookCloseBtn.addEventListener('click', function (e) {
      e.stopPropagation(); // don't trigger the bubble's open-chat handler
      dismissHook(true);
    });
    ui.hook = el('div', { class: 'aeoc-chat-hook', role: 'button', 'aria-label': 'Open chat' }, [ui.hookText, hookCloseBtn]);
    ui.hook.addEventListener('click', function () {
      // Tapping the hook question sends it as the opening message (no generic "Hi."),
      // so one tap lands straight in an answered conversation. Guarded to the opening turn.
      if (!state.sentOpening) state.hookQuestion = ui.hookText.textContent || '';
      dismissHook(true);
      openPanel();
    });

    // Hook stack (MULTI_HOOK) — container + close button built once; the
    // question pills are filled per-page in showHook().
    ui.hookStack = el('div', { class: 'aeoc-chat-hookstack' });
    var stackClose = el('button', { class: 'aeoc-chat-hookstack-close', 'aria-label': 'Dismiss', text: '✕' });
    stackClose.addEventListener('click', function (e) {
      e.stopPropagation();
      dismissHook(true);
    });
    ui.hookStack.appendChild(stackClose);

    document.body.appendChild(ui.launcher);
    document.body.appendChild(ui.panel);
    document.body.appendChild(ui.hook);
    document.body.appendChild(ui.hookStack);
  }

  // --- ATC dodge: while the stack is up, duck out of the way whenever the
  // in-flow add-to-cart button occupies the bottom corner zone — the buy
  // button always wins. Buttons inside fixed/sticky bars are excluded here
  // (the mobile fixed bar is cleared by the stack's 140px mobile offset).
  function aeocInFixedBar(node) {
    for (var n = node; n && n !== document.body; n = n.parentElement) {
      try { var p = getComputedStyle(n).position; if (p === 'fixed' || p === 'sticky') return true; }
      catch (e) { return false; }
    }
    return false;
  }
  function setupAtcDodge() {
    if (state.atcDodgeHandler) return;
    var btns = [];
    try {
      document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], button[name="add"]')
        .forEach(function (b) { if (!aeocInFixedBar(b)) btns.push(b); });
    } catch (e) { /* selector support — dodge is an enhancement, never fatal */ }
    if (!btns.length) return;
    var ticking = false;
    state.atcDodgeHandler = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!ui.hookStack || !ui.hookStack.classList.contains('aeoc-chat-hookstack-visible')) return;
        var vh = window.innerHeight, overlap = false;
        for (var i = 0; i < btns.length; i++) {
          var r = btns[i].getBoundingClientRect();
          if (r.width && r.bottom > vh - 150 && r.top < vh) { overlap = true; break; }
        }
        // Only the pills duck out of the way — the launcher never moves.
        ui.hookStack.classList.toggle('aeoc-chat-hookstack-tucked', overlap);
      });
    };
    window.addEventListener('scroll', state.atcDodgeHandler, { passive: true });
    window.addEventListener('resize', state.atcDodgeHandler);
    state.atcDodgeHandler();
  }
  function teardownAtcDodge() {
    if (state.atcDodgeHandler) {
      window.removeEventListener('scroll', state.atcDodgeHandler);
      window.removeEventListener('resize', state.atcDodgeHandler);
      state.atcDodgeHandler = null;
    }
  }

  function showHook() {
    if (state.hookShown || state.opened || hooksExhausted()) return;
    var ctx = detectPageContext();
    if (MULTI_HOOK) {
      var qs = pickHookStack(ctx.handle);
      if (!qs.length) return;
      // (Re)fill the pills — the close button stays as first child.
      while (ui.hookStack.childNodes.length > 1) ui.hookStack.removeChild(ui.hookStack.lastChild);
      qs.forEach(function (q) {
        var pill = el('button', { class: 'aeoc-chat-hookpill', text: q });
        pill.addEventListener('click', function () {
          // Tapping a pill sends that question as the opening message (no ghost "Hi.").
          if (!state.sentOpening) state.hookQuestion = q;
          dismissHook(true);
          openPanel();
        });
        ui.hookStack.appendChild(pill);
      });
      ui.hookStack.classList.add('aeoc-chat-hookstack-visible');
      setupAtcDodge();
    } else {
      var text = pickHookText(ctx.handle);
      if (!text) return;
      ui.hookText.textContent = text;
      ui.hook.classList.add('aeoc-chat-hook-visible');
    }
    state.hookShown = true;
    bumpHookShowCount();
    // Auto-hide after 12s if untouched — an ignore, not a refusal, so this page only.
    state.hookAutoHideTimer = setTimeout(function () {
      if ((ui.hook && ui.hook.classList.contains('aeoc-chat-hook-visible')) ||
          (ui.hookStack && ui.hookStack.classList.contains('aeoc-chat-hookstack-visible'))) dismissHook(false);
    }, 12000);
  }

  // acted === true  → she engaged or refused; done for the session.
  // acted === false → it merely timed out; this page only, next page may hook again.
  function dismissHook(acted) {
    if (state.hookAutoHideTimer) { clearTimeout(state.hookAutoHideTimer); state.hookAutoHideTimer = null; }
    if (ui.hook) ui.hook.classList.remove('aeoc-chat-hook-visible');
    if (ui.hookStack) {
      ui.hookStack.classList.remove('aeoc-chat-hookstack-visible');
      ui.hookStack.classList.remove('aeoc-chat-hookstack-tucked');
    }
    if (ui.launcher) ui.launcher.classList.remove('aeoc-chat-tucked'); // belt-and-braces: never leave the icon hidden
    teardownAtcDodge();
    if (acted) markHookDismissed(); else state.hookShown = true;
    teardownHookTriggers();
  }

  function teardownHookTriggers() {
    if (state.hookDelayTimer) { clearTimeout(state.hookDelayTimer); state.hookDelayTimer = null; }
    if (state.hookScrollHandler) {
      window.removeEventListener('scroll', state.hookScrollHandler);
      state.hookScrollHandler = null;
    }
  }

  function scheduleHook() {
    if (hooksExhausted()) return;

    // Trigger 1: 22-second timer
    state.hookDelayTimer = setTimeout(function () {
      teardownHookTriggers();
      showHook();
    }, 22000);

    // Trigger 2: scroll past 25% of the document
    state.hookScrollHandler = function () {
      var docHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = window.scrollY / docHeight;
      if (pct >= 0.25) {
        teardownHookTriggers();
        showHook();
      }
    };
    window.addEventListener('scroll', state.hookScrollHandler, { passive: true });
  }

  function autosize() {
    ui.input.style.height = 'auto';
    ui.input.style.height = Math.min(ui.input.scrollHeight, 90) + 'px';
  }

  function openPanel() {
    state.opened = true;
    ui.panel.classList.add('aeoc-chat-open');
    ui.launcher.classList.add('aeoc-chat-hidden');
    // Hook (single or stack) never shows after the panel is open — she's in.
    dismissHook(true);
    setTimeout(function () { ui.input.focus(); }, 100);

    // Mobile keyboard fix — resize panel ONLY when keyboard is clearly open.
    // Idempotent: only attach listeners on first openPanel() call.
    // Transient visualViewport events fire during page-shift / zoom-cancel /
    // chrome-collapse without the keyboard being up — applying inline styles
    // during those intermediate states was pushing the panel off-screen.
    // Threshold: keyboard reduces visualViewport.height by at least 150px
    // (smallest soft keyboard is ~250px; 150 leaves safe margin).
    if (window.visualViewport && !state.viewportListenersAttached) {
      state.viewportListenersAttached = true;
      function handleViewportResize() {
        if (!window.matchMedia('(max-width: 640px)').matches) return;
        if (!ui.panel) return;
        var vv = window.visualViewport;
        var keyboardOpen = (window.innerHeight - vv.height) >= 150;
        if (keyboardOpen) {
          ui.panel.style.height = vv.height + 'px';
          ui.panel.style.top = vv.offsetTop + 'px';
          if (ui.messages) ui.messages.scrollTop = ui.messages.scrollHeight;
        } else {
          // Keyboard closed (or never was open) — clear inline styles so CSS resumes.
          ui.panel.style.height = '';
          ui.panel.style.top = '';
        }
      }
      window.visualViewport.addEventListener('resize', handleViewportResize);
      window.visualViewport.addEventListener('scroll', handleViewportResize);
    }

    // GA4 attribution: fire once per session when the panel first opens.
    if (!state.ga4OpenedFired) {
      state.ga4OpenedFired = true;
      trackGa4('chatbot_opened', {
        chatbot_session_id: state.sessionId,
        page_context: state.pageContext || '',
        page_handle: state.pageHandle || '',
        page_path: (typeof window.location !== 'undefined' ? window.location.pathname : '')
      });
      // Persist a session-scoped user property so EVERY subsequent GA4 event in this
      // session (including the Shopify purchase event) is taggable as Tony-influenced.
      setGa4UserProperty('chatbot_engaged_this_session', 'true');
      setGa4UserProperty('chatbot_session_id', state.sessionId);
      // Layer 3: tag the Shopify cart so the attribute follows into any order placed.
      tagShopifyCart();
      persistConversation();
    }

    // If there's a persisted conversation from a previous page in this tab session,
    // re-render the bubbles into the panel so she can see her history.
    // sentOpening guard skips the auto-greeting if she's already had one this session.
    if (state.messages.length > 0 && !ui.messages.firstChild) {
      for (var i = 0; i < state.messages.length; i++) {
        var m = state.messages[i];
        if (m && !m.internal && (m.role === 'user' || m.role === 'assistant')) {
          addBubble(m.role === 'assistant' ? 'bot' : 'user', m.content || '');
        }
      }
    }

    if (!state.sentOpening) {
      state.sentOpening = true;
      if (state.hookQuestion) {
        // Opened via a hook question — send it as a real first message (engaged, no ghost "Hi.").
        var q = state.hookQuestion;
        state.hookQuestion = null;
        ui.input.value = q;
        handleSend();
      } else {
        sendOpening();
      }
      persistConversation();
    }
  }

  function closePanel() {
    ui.panel.classList.remove('aeoc-chat-open');
    ui.launcher.classList.remove('aeoc-chat-hidden');
  }

  function addBubble(role, text) {
    // Bot bubbles render markdown; user bubbles stay plain text (no injection risk from typed input).
    var attrs = { class: 'aeoc-chat-bubble ' + (role === 'user' ? 'aeoc-chat-user' : 'aeoc-chat-bot') };
    if (role === 'user') {
      attrs.text = text || '';
    } else {
      attrs.html = renderMarkdown(text || '');
    }
    var bubble = el('div', attrs);
    ui.messages.appendChild(bubble);
    scrollToBottom();
    return bubble;
  }

  function addTypingIndicator() {
    var t = el('div', { class: 'aeoc-chat-typing' }, [
      el('span'), el('span'), el('span')
    ]);
    ui.messages.appendChild(t);
    scrollToBottom();
    return t;
  }

  function showError(text) {
    var e = el('div', { class: 'aeoc-chat-error', text: text });
    ui.messages.appendChild(e);
    scrollToBottom();
  }

  function scrollToBottom() {
    ui.messages.scrollTop = ui.messages.scrollHeight;
  }

  function removeChips() {
    if (ui.chips && ui.chips.parentNode) ui.chips.parentNode.removeChild(ui.chips);
    ui.chips = null;
  }

  function renderChips() {
    var ctx = detectPageContext();
    var chips = pickChips(ctx.handle);
    if (!chips || !chips.length) return;
    removeChips();
    var wrap = el('div', { class: 'aeoc-chat-chips' });
    for (var i = 0; i < chips.length; i++) {
      (function (txt) {
        var b = el('button', { class: 'aeoc-chat-chip', type: 'button', text: txt });
        b.addEventListener('click', function () {
          removeChips();
          ui.input.value = txt;
          handleSend();
        });
        wrap.appendChild(b);
      })(chips[i]);
    }
    ui.chips = wrap;
    ui.messages.appendChild(wrap);
    scrollToBottom();
  }

  function handleSend() {
    if (state.isStreaming) return;
    var text = ui.input.value.trim();
    if (!text) return;
    removeChips();
    ui.input.value = '';
    autosize();
    addBubble('user', text);
    state.messages.push({ role: 'user', content: text });
    persistConversation();

    // GA4: fire once on the first real user message (engagement, not just opened-and-closed)
    if (!state.ga4EngagedFired) {
      state.ga4EngagedFired = true;
      trackGa4('chatbot_engaged', {
        chatbot_session_id: state.sessionId,
        page_context: state.pageContext || '',
        page_handle: state.pageHandle || '',
        first_message_length: text.length
      });
    }

    streamReply(state.messages, true);
  }

  function sendOpening() {
    // Opening is a UI flourish — not rendered as a user bubble — but it IS persisted
    // to state.messages so subsequent turns carry full context to the server. Without
    // this, the next "first real message" arrives at the server alone, the server sees
    // turn=1 with no history, and the bot can re-greet instead of answering (see
    // 2026-05-15 session 087a5076 in the chat log). Marked internal so the restoration
    // loop in openPanel() skips re-rendering it as a bubble after navigation.
    state.messages.push({ role: 'user', content: 'Hi.', internal: true });
    state.showChipsAfterReply = true;
    streamReply(state.messages, true);
  }

  function streamReply(messagesToSend, persistToHistory) {
    if (state.messages.length > 40) {
      showError('Long conversation — for detail please email hello@australianeucalyptusoil.com.au.');
      return;
    }

    state.isStreaming = true;
    ui.sendBtn.disabled = true;
    var typing = addTypingIndicator();
    var botBubble = null;
    var botText = '';

    // Read live context each send so the preview simulator (and SPA navigation) works.
    var live = detectPageContext();
    state.pageContext = live.title;
    state.pageHandle = live.handle;

    var payload = {
      messages: messagesToSend,
      pageContext: state.pageContext,
      pageHandle: state.pageHandle,
      sessionId: state.sessionId
    };

    fetch(CONFIG.workerUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (resp) {
      if (!resp.ok) {
        return resp.text().then(function (t) { throw new Error('HTTP ' + resp.status + ': ' + t); });
      }
      if (!resp.body || !resp.body.getReader) {
        throw new Error('Streaming not supported in this browser');
      }
      var reader = resp.body.getReader();
      var decoder = new TextDecoder('utf-8');
      var buffer = '';

      function pump() {
        return reader.read().then(function (r) {
          if (r.done) {
            finalize();
            return;
          }
          buffer += decoder.decode(r.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop();
          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (!line) continue;
            if (line.indexOf('data:') !== 0) continue;
            var data = line.slice(5).trim();
            if (!data || data === '[DONE]') continue;
            try {
              var ev = JSON.parse(data);
              if (ev.type === 'content_block_delta' && ev.delta && ev.delta.type === 'text_delta') {
                var token = ev.delta.text;
                if (!botBubble) {
                  if (typing && typing.parentNode) typing.parentNode.removeChild(typing);
                  typing = null;
                  botBubble = addBubble('bot', '');
                }
                botText += token;
                botBubble.innerHTML = renderMarkdown(botText);
                scrollToBottom();
              } else if (ev.type === 'error') {
                throw new Error(ev.error && ev.error.message ? ev.error.message : 'API error');
              }
            } catch (e) {
              // ignore JSON parse hiccups on partial chunks
            }
          }
          return pump();
        });
      }

      function finalize() {
        if (typing && typing.parentNode) typing.parentNode.removeChild(typing);
        if (botText && persistToHistory) {
          var msg = { role: 'assistant', content: botText };
          // Match the internal flag of the preceding user message so the opening
          // greeting pair stays out of the rendered history on page navigation.
          var prev = state.messages[state.messages.length - 1];
          if (prev && prev.internal) msg.internal = true;
          state.messages.push(msg);
        }
        state.isStreaming = false;
        ui.sendBtn.disabled = false;
        // Opening greeting done → offer tappable quick-reply chips (cuts the ghost-open drop-off).
        if (state.showChipsAfterReply) {
          state.showChipsAfterReply = false;
          if (botText) renderChips();
        }
        // Persist the completed conversation so it survives page navigation in this tab.
        persistConversation();
      }

      return pump();
    }).catch(function (err) {
      console.error('[AEOC] chat error:', err);
      if (typing && typing.parentNode) typing.parentNode.removeChild(typing);
      showError('Connection hiccup — try again in a moment.');
      if (persistToHistory) state.messages.pop();
      state.isStreaming = false;
      ui.sendBtn.disabled = false;
    });
  }

  function init() {
    var ctx = detectPageContext();
    state.pageContext = ctx.title;
    state.pageHandle = ctx.handle;
    build();
    scheduleHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
